import { NgModule } from "@angular/core";

import { c_card_cloud_ai_stat_module } from "./analtics/video-ai-stat/c_card_cloud_ai_stat.module"
import { c_card_calendar_module } from './event-viewer/calendar/c_card_calendar.module'
import { c_card_heat_map_module } from './event-viewer/heat-map/c_card_heat_map.module'
import { c_card_event_viewer_box_module } from './event-viewer/event-viewer-box/c_card_event_viewer_box.module'
import { c_card_event_viewer_time_line_module } from "./event-viewer-time-line/event-viewer-time-line-box/c_card_event_viewer_time_line.module";
import { c_card_event_viewer_time_line_summary_input_area_module } from "./event-viewer-time-line/summary-input-area/c_card_event_viewer_time_line_summary_input_area.module";
import { c_card_site_plan_v3_module } from './site-plan-v3/c_card_site_plan_v3.module'
import { c_map_module } from './google-map/c_map.module'
import { c_card_need_bridge_module } from './need-bridge/c_card_need_bridge.module'
import { c_card_mp_session_time_line_module } from './mp-session/c_card_mp_session_time_line.module'
import { c_card_scheduled_arming_module } from './scheduled-arming/c_card_scheduled_arming.module'
import { c_card_stat_widget_module } from './site-info/stat-widget/c_card_stat_widget.module'
import { c_card_arming_status_widget_module } from './site-info/arming-status-widget/c_card_arming_status_widget.module'
import { c_card_need_permission_module } from './need-permission/c_card_need_permission.module'

@NgModule({
  exports: [
    c_card_cloud_ai_stat_module,
    c_card_calendar_module,
    c_card_heat_map_module,
    c_card_event_viewer_box_module,
    c_card_event_viewer_time_line_module,
    c_card_event_viewer_time_line_summary_input_area_module,
    c_card_site_plan_v3_module,
    c_map_module,
    c_card_need_bridge_module,
    c_card_mp_session_time_line_module,
    c_card_scheduled_arming_module,
    c_card_stat_widget_module,
    c_card_arming_status_widget_module,
    c_card_need_permission_module
  ],
})
export class c_card_module {}
